import { useCancelOrderMutation } from "@/api/marketplace/cancelOrder";
import type { ListOrdersResponse } from "@/api/marketplace/getOrders";
import { useSeaport } from "@/hooks/useSeaport";
import { Button, Group } from "@mantine/core";

type CancelOfferButtonProps = {
	order: ListOrdersResponse["orders"][number];
};

export default function CancelOfferButton({ order }: CancelOfferButtonProps) {
	const { fulfillOrder } = useSeaport();
	const cancelOrders = useCancelOrderMutation();
	return (
		<Group mt="md">
			{import.meta.env.VITE_NODE_ENV !== "production" && (
				<Button
					flex={1}
					variant="filled"
					onClick={() =>
						fulfillOrder.mutate({
							parameters: order.orderData,
							signature: order.signature,
						})
					}
					loading={fulfillOrder.isPending}
					disabled={fulfillOrder.isPending}
				>
					Fulfill Order
				</Button>
			)}
			<Button
				flex={1}
				variant="filled"
				color="red"
				onClick={() => cancelOrders.mutate({ orderHashes: [order.orderHash] })}
				loading={cancelOrders.isPending}
				disabled={cancelOrders.isPending}
			>
				Cancel Order
			</Button>
		</Group>
	);
}
